// @ts-strict-ignore
import { HTMLAttributes, ReactNode } from 'react'

import { IPortIcon } from '@/shared/lib/icons'
import { Icon } from '@/shared/ui/icon'

import cl from './feature-block.module.scss'

export interface FeatureBlockProps extends HTMLAttributes<HTMLDivElement> {
	icon?: IPortIcon
	customIcon?: ReactNode
	heading: ReactNode
	description: ReactNode
}

export const FeatureBlock = (props: FeatureBlockProps) => {
	const { icon, customIcon, heading, description } = props

	return (
		<div className={cl.service}>
			{(icon || customIcon) && (
				<div className={cl.service__icon}>{customIcon ? customIcon : <Icon name={icon} className={cl.icon} />}</div>
			)}
			<div className={cl.service__title}>{heading}</div>
			<div className={cl.service__description}>{description}</div>
		</div>
	)
}
